import React from 'react';
import _ from 'lodash';

import Highlighter from 'react-highlight-words';
import { Button, Icon, Input } from 'antd';

import * as _s from '../../routes/Encanta21MagicEye/Encanta21.module.less';

export const emptyVal = '<vazio>';

export const sleep = (ms = 1000) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const isObject = body => Boolean(body && typeof body === 'object');

export const objectHasValidArrayProp = (obj, propName) =>
  Boolean(
    isObject(obj) &&
      obj.hasOwnProperty(propName) &&
      Array.isArray(obj[propName]) &&
      obj[propName].length
  );

export const getNumberFromStr = numStr => {
  if (typeof numStr === 'number') {
    return numStr;
  } else if (typeof numStr === 'string') {
    const num = Number(numStr.replace(/%/gm, ''));
    if (!Number.isNaN(num)) {
      return num;
    }
  }
  return undefined;
};

export const tryPushingDataToObjectsArrayProp = (obj, propName, val, shouldBeUnique = false) => {
  if (!(isObject(obj) && typeof propName === 'string' && val)) {
    return;
  }

  if (obj.hasOwnProperty(propName)) {
    if (Array.isArray(obj[propName]) && (shouldBeUnique ? !obj[propName].includes(val) : true)) {
      obj[propName].push(val);
    }
  } else {
    obj[propName] = [val];
  }
};

export const capitalizeString = str => {
  if (!(str && typeof str === 'string')) {
    return str;
  }

  return str[0].toUpperCase() + str.slice(1);
};

export const isObjectWithProps = obj => Boolean(isObject(obj) && Object.keys(obj).length);

export const reduceArrayOfNumToSingleNum = arrOfNum =>
  arrOfNum.reduce((previousValue, currentValue) => Number(previousValue) + Number(currentValue), 0);

export const initialFiltersState = {
  searchText: '',
  searchedColumn: undefined,
  searchedColumns: []
};

export const isFilledArray = val => objectHasValidArrayProp({ val }, 'val');

export const deepCopy = stringfiableData => {
  try {
    const value = JSON.parse(JSON.stringify(stringfiableData));
    return value;
  } catch {
    return stringfiableData;
  }
};

export const formatPercentage = (value, decimalPlaces = 2) =>
  typeof value === 'string' && value.includes('%')
    ? value
    : Number.isNaN(value) || typeof value !== 'number'
    ? '-'
    : value < 0
    ? '0%'
    : value <= 1
    ? _.round(value * 100, decimalPlaces) + '%'
    : _.round(value, decimalPlaces) + '%';

export const isValidStoneEmail = email =>
  RegExp(/^[\w\-._+%]+@(stone\.com\.br|pagar\.me)/).test(email);

export const masked = (value, pattern) => {
  let i = 0;
  const v = value.toString();

  return pattern.replace(/#/g, () => v[i++] || '');
};

export const formatDocument = document => {
  if (document.length === 11) {
    return masked(document, '###.###.###-##');
  }

  return masked(document, '##.###.###/####-##');
};

const filterComparation = (a, b) => {
  return (!a && !b) || String(a).toLowerCase() === String(b).toLowerCase();
};

export const getChannelColsProp = (channelPropName, dataSource, shouldConsiderChildren) => {
  const extraChannels = [];
  const baseChannels = [
    emptyVal,
    'Reclame Aqui',
    'Facebook',
    'Chat',
    'Telefone',
    'Email',
    'WhatsApp',
    'Escritos',
    'Unificado'
  ];
  const usefulBaseChannels = baseChannels.filter(channel =>
    dataSource.some(({ [channelPropName]: recordChannel }) => {
      if (!baseChannels.includes(recordChannel)) {
        extraChannels.includes(recordChannel);
      }
      return filterComparation(recordChannel, channel);
    })
  );

  const filterChannels = usefulBaseChannels.concat(extraChannels);

  return {
    filters: filterChannels.map(channel => ({ text: channel, value: channel.toLowerCase() })),
    onFilter: (value, record) => {
      if (!shouldConsiderChildren) {
        const { [channelPropName]: channel } = record;
        return filterComparation(value, channel);
      }

      return record.children.some(({ [channelPropName]: channel }) =>
        filterComparation(value, channel)
      );
    }
  };
};

export const getContractColsProp = (contractPropName, dataSource) => {
  const allContracts = ['CLT', 'CLT*', 'TCE'].filter(channel =>
    dataSource.some(({ [contractPropName]: recordContract }) => recordContract === channel)
  );

  return {
    filters: allContracts.map(contract => ({ text: contract, value: contract })),
    onFilter: (value, { [contractPropName]: contract }) => value === contract
  };
};

export const getFormattedName = name => {
  const memberNameSeparator = ' |';

  if (name && typeof name === 'string' && name.includes(memberNameSeparator)) {
    const personsName = name.split(memberNameSeparator)[0];
    const personsNames = personsName.split(/\s/);

    return `${personsNames.shift()} ${personsNames.pop()}`;
  }

  return name;
};

export const getLocaleForTable = (emptyTableMessage = 'Não há registros.') => ({
  emptyText: emptyTableMessage
});

export const channelMapping = {
  '1': 'Telefone',
  '2': 'Chat',
  '3': 'Email',
  '4': 'WhatsApp',
  '13': 'Escritos'
};

export const getColName = (dataIndex, tabName) => `${dataIndex} ${tabName}`;

export const getColumnSearchProps = ({
  dataIndex,
  title,
  isLink,
  linkAction,
  handleSearch,
  handleClearFilters,
  currState,
  component,
  tabName,
  shouldFilterChildren
}) => {
  const { searchedColumn, searchedColumns } = currState;

  const thereAreColumnsFiltered =
    searchedColumn &&
    searchedColumns.some(columnObj => Object.keys(columnObj)[0] === getColName(dataIndex, tabName));

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => (component.searchInput = node)}
          placeholder={`Buscar por ${title}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, tabName)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex, tabName)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          id={tabName + title}
          onClick={() => handleClearFilters(clearFilters, dataIndex, tabName)}
          size="small"
          icon="delete"
          disabled={
            !(
              searchedColumns.some(
                columnObj => Object.keys(columnObj)[0] === getColName(dataIndex, tabName)
              ) && searchedColumn
            )
          }
        >
          Limpar Filtro
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon
        type="search"
        style={{ color: filtered && thereAreColumnsFiltered ? '#1890ff' : '#bfbfbf' }}
      />
    ),
    onFilter: (value, record) => {
      const formattedValue = value.toLowerCase();

      if (!thereAreColumnsFiltered) {
        return true;
      }

      if (shouldFilterChildren) {
        return (
          isFilledArray(record.children) &&
          record.children.some(({ [dataIndex]: indexValue }) =>
            String(indexValue)
              .toLowerCase()
              .includes(formattedValue)
          )
        );
      }

      return String(record[dataIndex])
        .toLowerCase()
        .includes(formattedValue);
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => component.searchInput.select());
      }
    },
    render: (text, obj) => {
      return thereAreColumnsFiltered ? (
        <span className={isLink ? _s.recordLink : ''} onClick={() => linkAction(obj)}>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[
              searchedColumns.filter(columnObj => {
                return columnObj[getColName(dataIndex, tabName)];
              })[0][getColName(dataIndex, tabName)]
            ]}
            autoEscape
            textToHighlight={String(text)}
          />
        </span>
      ) : isLink ? (
        <span className={_s.recordLink} onClick={() => linkAction(obj)}>
          {text}
        </span>
      ) : (
        text
      );
    }
  };
};

export const handleSearch = (currState, selectedKeys, confirm, dataIndex, tabName) => {
  const { searchedColumns } = currState;
  let newSearchedColumns = [...searchedColumns];
  const colName = getColName(dataIndex, tabName);

  if (Array.isArray(selectedKeys) && selectedKeys.length) {
    const searchedColumn = {};
    searchedColumn[colName] = selectedKeys[0];

    const isColumnAlreadyThere = newSearchedColumns.some(
      columnObj => Object.keys(columnObj)[0] === colName
    );
    if (!isColumnAlreadyThere) {
      newSearchedColumns.push(searchedColumn);
    } else {
      newSearchedColumns.forEach(columnObj => {
        if (Object.keys(columnObj)[0] === colName) {
          columnObj[colName] = selectedKeys[0];
        }
      });
    }
  } else {
    newSearchedColumns = newSearchedColumns.filter(col => !col.hasOwnProperty(colName));
  }

  confirm();
  return {
    searchText: selectedKeys[0] ? selectedKeys[0] : '',
    searchedColumn: dataIndex,
    searchedColumns: newSearchedColumns
  };
};

export const handleClearFilters = (currState, clearFilters, dataIndex, title) => {
  clearFilters();
  const { searchedColumns } = currState;
  const newSearchedColumns = searchedColumns.filter(
    columnObj => Object.keys(columnObj)[0] !== getColName(dataIndex, title)
  );

  return { searchText: '', searchedColumns: newSearchedColumns };
};

export const formatCollectionWithStringfiedValues = records => {
  return Array.isArray(records)
    ? records.map(record => {
        for (const key in record) {
          const isFieldValueATextAreaJSON = Boolean(
            typeof record[key] === 'string' &&
              (record[key].includes('{') || record[key].includes('['))
          );

          if (isFieldValueATextAreaJSON) {
            try {
              try {
                record[key] = JSON.parse(record[key].replace(/'|&quot;/g, '"'));
              } catch {
                record[key] = JSON.parse(record[key]);
              }
            } catch {
              console.error(`Impossível traduzir a chave ${key} do record`, record);
            }
          }
        }
        return record;
      })
    : undefined;
};

export const defaultSelectFilter = (input, option) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
